import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import logMapEvent from 'components/common/maps/amplitudeclickEvent';
import { showOfflineSpinner } from 'actions/app-state';
import { formatLink } from 'utils/helpers/resourcesMap';
import { MapLessonItemProps } from 'types';

const MapLessonItemBase: React.FC<MapLessonItemProps> = ({
  url,
  active,
  finishTime,
  svgElement,
  onClickCb,
}: MapLessonItemProps) => {
  const dispatch = useDispatch();

  const showAnimation = useCallback(() => {
    const field = localStorage.getItem('animationExpireTime');

    if (!field || (finishTime && +field < finishTime)) {
      localStorage.setItem('animationExpireTime', `${finishTime}`);
    }
    dispatch(showOfflineSpinner());
  }, [dispatch, finishTime]);

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();

      if (!active) {
        return;
      }

      onClickCb?.();

      if (url) {
        logMapEvent();
        window.open(formatLink(url), '_blank');
      } else {
        showAnimation();
      }
    },
    [active, showAnimation, url, onClickCb]
  );

  return (
    <g className={active ? 'for-touch' : 'no-touch'}>
      <a
        href={formatLink(url)}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
      >
        {svgElement}
      </a>
    </g>
  );
};

export default MapLessonItemBase;
